export default "__VITE_ASSET__B0JnO1JS__"